import { useForm } from '@mantine/form';

import { TSDViewEditGoodsItemFormValues } from '@e-origin/contracts';

export const useTSDViewEditGoodsItemFormInitializer = ({ houseConsignmentIdx, isMaster, goodsItemIdx, consignmentForm, onSave, onHide }) => {
  const houseConsignment = isMaster ? consignmentForm?.values?.master : consignmentForm?.values?.houseConsignment?.[houseConsignmentIdx];
  const goodsItem = houseConsignment?.consignmentItems?.[goodsItemIdx];

  const buildGoodsItemValues = (item) => ({
    goodsItemNumber: item?.goodsItemNumber || '',
    packaging: (item?.packaging ?? []).map((packaging) => ({
      typeOfPackages: packaging.typeOfPackages || '',
      numberOfPackages: packaging.numberOfPackages || '',
      shippingMarks: packaging.shippingMarks || '',
    })),
    commodity: {
      descriptionOfGoods: item?.commodity?.descriptionOfGoods || '',
      cusCode: item?.commodity?.cusCode || '',
      commodityCode: {
        hsCode: item?.commodity?.commodityCode?.hsCode || '',
        harmonizedSystemSubHeadingCode: item?.commodity?.commodityCode?.harmonizedSystemSubHeadingCode || '',
        combinedNomenclatureCode: item?.commodity?.commodityCode?.combinedNomenclatureCode || '',
      },
    },
    weight: {
      grossMass: item?.weight?.grossMass || '',
    },
    additionalSupplyChainActor: (item?.additionalSupplyChainActor ?? []).map((additionalSupplyChainActor) => ({
      role: additionalSupplyChainActor.role || '',
      identificationNumber: additionalSupplyChainActor.identificationNumber || '',
    })),
    transportEquipment: (item?.transportEquipment ?? []).map((transportEquipment) => ({
      containerIdentificationNumber: transportEquipment.containerIdentificationNumber || '',
      containerPackedStatus: transportEquipment.containerPackedStatus || '',
      numberOfSeals: transportEquipment.numberOfSeals || '',
      seal: (transportEquipment?.seal ?? []).map((seal) => ({
        identifier: seal.identifier || '',
      })),
    })),
    previousDocuments: (item?.previousDocuments || []).map((previousDocument) => ({
      type: previousDocument.type || '',
      referenceNumber: previousDocument.referenceNumber || '',
      goodsItemIdentifier: previousDocument.goodsItemIdentifier || '',
    })),
    additionalInformation: (item?.additionalInformation || []).map((additionalInformation) => ({
      code: additionalInformation.code || '',
      text: additionalInformation.text || '',
    })),
    supportingDocuments: (item?.supportingDocuments || []).map((supportingDocument) => ({
      type: supportingDocument.type || '',
      referenceNumber: supportingDocument.referenceNumber || '',
    })),
    additionalReference: (item?.additionalReference || []).map((additionalReference) => ({
      type: additionalReference.type || '',
      referenceNumber: additionalReference.referenceNumber || '',
    })),
  });

  const goodsItemForm = useForm<TSDViewEditGoodsItemFormValues>({
    initialValues: buildGoodsItemValues(goodsItem),
  });

  const onSubmit = async () => {
    onSave(goodsItemForm.values);
    onHide();
  };

  return { buildGoodsItemValues, goodsItemForm, onSubmit };
};
